module.exports = __webpack_public_path__ + "img/logo-text-color.eac611ee.png";